import React, { PureComponent, Fragment } from 'react';

import data from '~/assets/data/turnout.csv';
import historicalData from '~/assets/data/yearly_eu.csv';
import StaticMap from '~/kits/general/scripts/components/StaticMap';
import LineChart from '~/kits/general/scripts/components/LineChart';
import withSlide from '~/kits/general/scripts/components/withSlide';
import { getColorScale } from '~/kits/general/scripts/components/ComparisonMap/utils';
import Legend from '~/core/scripts/components/Legend';

import './TurnoutMap.styl';

const mapData = data.map(d => ({ key: d.country, value: d.rate }));
const chartData = historicalData.map(d => +d.turnout);

const colorScale = getColorScale([
  [40, '#7defe5'],
  [60, '#5fd3c9'],
  [70, '#3fb7ae'],
  [90, '#129b93']
]);

const maxLegendValue = 20;

class TurnoutMap extends PureComponent {
  render() {
    const { title, text } = this.props;

    return (
      <Fragment>
        <div className="slide-title">{title}</div>
        <div className="slide-text">{text}</div>
        <div className="turnout-map-wrapper">
          <StaticMap
            data={mapData}
            colorScale={colorScale}
            maxLegendValue={maxLegendValue}
            /*
            swoopies={[
              {
                lat: 43,
                lng: 12.5,
                text: 'Italien',
                style: { transform: 'translate(0, -100%)'}
              },
              {
                lat: 50.5,
                lng: 1.25,
                text: 'Belgien',
                style: { transform: 'translate(-100%, -100%)' },
                iconStyle: { transform: 'scaleX(-1)', 'left': '40px' } }
            ]}*/
          />
          <div className="mini-chart">
            <div className="mini-chart-label">Wahlbeteiligung seit 1979</div>
            <LineChart data={chartData} />
          </div>
        </div>
        <Legend
          maxLabel={`${colorScale.values[3]} %` || 'min'}
          minLabel={`${maxLegendValue} %` || 'max'}
          colors={colorScale.colors}
        />
      </Fragment>
    );
  }
}

export default withSlide(TurnoutMap);
